<template>
    <div>
        <p>This is a ZIP archive which comes with script launchers for all supported platforms. Java Runtime is not included.</p>

        <div class="p-3">
            <strong>GanttProject {{ version }}</strong>
            <div class="help-text pb-3">Released on {{ releaseDate }}</div>
            <a role="button" class="btn btn-attention btn-lg" :href="`/dl/${version}/any`">Download</a>
        </div>

        <p><strong>Install Java Runtime</strong></p>
        <p>GanttProject {{ version }} requires Java Runtime version 7 or higher.
            Currently there is a number of Java Runtime vendors and versions.
            GanttProject works with any OpenJDK compatible Java Runtime, however, due to packaging
            and other reasons, it may not work out of the box with some combinations of operating system,
            Java Runtime vendor and version.</p>

        <p>Make sure that Java Runtime Environment (JRE) for your platform is installed
            and  that you can run <code>java</code> from the command line.
            Download a <a :href="`/dl/${version}/any`">ZIP archive</a>
            unzip it in your home directory (<code>$HOME</code> on Unix systems) and run a launcher
            script (<code>ganttproject.sh</code> on Linux, <code>ganttproject.bat</code> on Windows,
            <code>ganttproject.command</code> on macOS) from
            <code>$HOME/ganttproject-{{version}}</code> directory.</p>
        <p><a href="https://github.com/bardsoftware/ganttproject/wiki/Installing-from-ZIP" target="_blank">
            Read more</a> about ZIP package on our Wiki.</p>

    </div>
</template>

<script>
    export default {
        name: "DownloadZip28",
        props: {
            releaseDate: String,
            version: String,
        }
    }
</script>

<style scoped>

</style>
